import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Navbar, Nav, NavbarBrand, NavbarToggler, NavItem, NavLink, Collapse, ButtonDropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';
import { capitalizeFirstLetter } from '../../../../util/text';

import { getLanguagePath } from '../../../Intl/IntlActions';
import { getLoggedUser, getUserPreference } from '../../../User/UserActions';

class AdminMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }


    getRoutes() {
        return [
            {
                to: '/console',
                name: '',
                picto: 'tachometer-alt',
                allowedRoles: ['admin'],
            },
            // {
            //     type: 'divider',
            //     allowedRoles: ['admin'],
            // },
            // {
            //     type: 'title',
            //     name: 'administrationTitle',
            //     allowedRoles: ['admin'],
            // },
            {
                to: '/console/orders/pendingpayment',
                name: 'orders',
                picto: 'list',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/reviews/pending',
                name: 'reviews',
                picto: 'star',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/vouchers',
                name: 'vouchers',
                picto: 'tags',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/products',
                name: 'products',
                picto: 'cube',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/users',
                name: 'users',
                picto: 'users',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/contents',
                name: 'cms',
                picto: 'pen',
                allowedRoles: ['admin'],
            },
            {
                to: '/console/config',
                name: '',
                picto: 'cogs',
                allowedRoles: ['admin'],
            },
        ];
    }

    isRouteAllowed(route) {
        return (
            !route.allowedRoles
            || (this.props.user && this.props.user.role && route.allowedRoles.includes(this.props.user.role))
        );
    }

    toggleDropdown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    renderRoutes(routes, level = 0) {
        return routes
            .filter(route => this.isRouteAllowed(route))
            .map((route, index) => {
                if(route.type === 'divider') {
                    return <NavItem key={index} className="p-2 sidebar-divider text-secondary">|</NavItem>;
                } if(route.type === 'title') {
                    return (
                        <NavItem key={index} className="d-block sidebar-heading">
                            <span className="p-2" style={{ position: 'absolute', top: '0' }}><FormattedMessage id={route.name} /></span>
                        </NavItem>
                    );
                }
                return (
                    <NavItem key={index}>
                        <Link to={getLanguagePath(route.to, getUserPreference(this.props.user, 'language'))} className={`nav-link ${this.props.location.pathname === route.to ? 'text-success' : 'text-gray-800'} p-1`}>
                            <span className="icon"><FontAwesome name={route.picto} size="lg" /></span> <span className="d-none d-md-inline p-1 text">{route.name && <FormattedMessage id={route.name} defaultMessage={capitalizeFirstLetter(route.name)} />}</span>
                        </Link>
                    </NavItem>
                );
            }).filter(route => route);
    }

    render() {
        if(this.props.user) {
            return (
                <Nav className="m-0 mt-4 mt-md-0 px-0">
                    {this.renderRoutes(this.getRoutes())}
                </Nav>
            );
        }
        return null;
    }
}

function mapStateToProps(store) {
    return {
        user: getLoggedUser(store),
    };
}

AdminMenu.defaultProps = {
    user: null,
};

AdminMenu.propTypes = {
    location: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export default connect(mapStateToProps)(withRouter(AdminMenu));
